import React from 'react';
import { ScaleIcon } from 'lucide-react';
import { Section } from './Shared';
import { costRows } from '../data/costRows';
export function CostTable() {
  return <Section className="max-w-4xl" data-id="element-66" data-mp="27lghliuyubzq">
      <h2 className="flex flex-wrap items-center justify-center gap-x-2 text-center text-2xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-67" data-mp="1tsh4tomkivvv">
        <ScaleIcon className="h-7 w-7 text-amber-700" aria-hidden="true" data-id="element-68" data-mp="1yrach0f6bso4" />
        Quanto ti costa non avere un metodo?
      </h2>

      <div className="mt-10 overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm" data-id="element-69" data-mp="2qhy8xz5wk9vg">
        <table className="w-full text-left text-sm md:text-base" data-id="element-70" data-mp="2cip4fwr2747b">
          <thead className="bg-emerald-800 text-white" data-id="element-71" data-mp="2ckjf8i8m9fxo">
            <tr data-id="element-72" data-mp="2hgqke8t6unek">
              <th scope="col" className="px-4 py-3 font-semibold md:px-6" data-id="element-73" data-mp="2hg8gcq0ab4w3">
                Senza una struttura
              </th>
              <th scope="col" className="px-4 py-3 font-semibold md:px-6" data-id="element-74" data-mp="115ctz30snnc6">
                Conseguenza nel lavoro
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-stone-200" data-id="element-75" data-mp="2nj78ljgml9lx">
            {costRows.map(row => <tr key={row.without} data-id="element-76" data-mp="2jhm00ab4jhhj">
                <th scope="row" className="px-4 py-3 font-semibold text-emerald-900 md:px-6" data-id="element-77" data-mp="2jinaodo8a1yq">
                  {row.without}
                </th>
                <td className="px-4 py-3 text-stone-700 md:px-6" data-id="element-78" data-mp="2sgza9572oa3b">{row.consequence}</td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <p className="mx-auto mt-8 max-w-2xl text-center text-base font-medium leading-relaxed text-stone-900 md:text-lg" data-id="element-79" data-mp="36fgtoqpy30ff">
        Chi ha un metodo può spiegare meglio il proprio lavoro. Chi spiega meglio il proprio lavoro rende più chiaro il
        valore del percorso.
      </p>
    </Section>;
}